var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.user.token && _vm.$org.httponly_cookie)?_c('div',{staticStyle:{"height":"0","width":"0"}},[_c('iframe',{ref:"httponly_token",staticStyle:{"width":"0","height":"0"},attrs:{"src":_vm.url,"frameborder":"0"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }